import { defineMessages } from '@dragonraider5/react-intl'

export default defineMessages({
  register: {
    id: 'containers.MainStepper.steps.register',
    description: 'Step name register',
    defaultMessage: 'Solicitud y registro'
  },
  project: {
    id: 'containers.MainStepper.steps.project',
    description: 'Step name project',
    defaultMessage: 'Sobre el proyecto'
  },
  organization: {
    id: 'containers.MainStepper.steps.organization',
    description: 'Step name organization',
    defaultMessage: 'Sobre la organización'
  },
  documments: {
    id: 'containers.MainStepper.steps.documments',
    description: 'Step name documments',
    defaultMessage: 'Documentos fiscales'
  }
})
